module.exports = __webpack_public_path__ + "img/ico_feed_casino@3x.acd5623c.png";